import {additionalFieldsData} from "../../variables/additional-fields-data";

export const validateEmail = (email) => {
    const res = additionalFieldsData.email.regexp;
    return res.test(email);
}
